import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageManagerService {

  constructor() { }

  getPreviousChatData(key:any): any {
    return localStorage.getItem(key) as string;
  }

  removePreviousChatData(key:any): void {
    localStorage.removeItem(key);
  }

  setPreviousChatData(key:any, value:any): void {
    localStorage.setItem(key, value);
  }
}
